import { api } from "../../helpers/api/handler"

export const unimpersonate = () => api.get<void>(`/auth/user?__unimpersonate`)
